import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {IFebActiviteUoNomenclature} from 'src/app/shared/models/feb-activite-uo-nomenclature';
import {AuthenticationService} from 'src/app/shared/services/authentication.service';
import {CurrentUserService} from 'src/app/shared/services/current-user.service';
import {UtilsService} from 'src/app/shared/services/utils.service';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FebActiviteUoNomenclatureService {

  private createAuditHeaders(): HttpHeaders {
    const currentUser = this.currentUserService.getCurrentUser() as any || {};

    const requestId = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    const role = currentUser?.role ?? '';
    const displayName = currentUser.displayName ?? `${currentUser.firstName ?? ''} ${currentUser.lastName ?? ''}`.trim();

    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'X-User-Identifier': currentUser.identifier ?? '',
      'X-User-Display-Name': displayName,
      'X-User-Role': role,
      'X-Actor-Source': 'FE',
      'X-Request-ID': requestId
    });
  }

  get options() {
    return {
      headers: this.createAuditHeaders()
    };
  }

  constructor(
    private http: HttpClient,
    private utilsService: UtilsService,
    private authenticationService: AuthenticationService,
    private currentUserService: CurrentUserService
  ) {}
  private handleError(err: HttpErrorResponse) {
    console.error(`[FebActiviteUoNomenclatureService] Code erreur : ${err.status}`, err.error);
    return throwError(() => {
      return err
    });
  }

  getAll(): Observable<IFebActiviteUoNomenclature[]> {
    return this.http.get<IFebActiviteUoNomenclature[]>(environment.backendApiUrl + '/admin/feb-activite-uo-nomenclature', this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  create(nomenclature: IFebActiviteUoNomenclature): Observable<IFebActiviteUoNomenclature> {
    return this.http.post<IFebActiviteUoNomenclature>(environment.backendApiUrl + '/admin/feb-activite-uo-nomenclature', nomenclature, this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  update(id: string, nomenclature: IFebActiviteUoNomenclature): Observable<IFebActiviteUoNomenclature> {
    const resolvedId = id || nomenclature.nomenclatureId || nomenclature.id || '';
    return this.http.put<IFebActiviteUoNomenclature>(environment.backendApiUrl + '/admin/feb-activite-uo-nomenclature/' + resolvedId, nomenclature, this.options)
      .pipe(catchError((err) => this.handleError(err)));
  }

  delete(nomenclature: IFebActiviteUoNomenclature): Observable<any> {
    const id = nomenclature.nomenclatureId ?? nomenclature.id;
    return this.http.delete<any>(environment.backendApiUrl + '/admin/feb-activite-uo-nomenclature/' + id, this.options)
      .pipe(catchError(this.utilsService.handleError));
  }
  exportFebActiviteUONomenclatureData(): Observable<any> {
    return this.http.get(environment.backendApiUrl + "/admin/feb-activite-uo-nomenclature/export/", {responseType: 'blob'}).pipe(catchError(this.utilsService.handleError));
  }
}
